import * as React from "react";
import { Button, Link, styled } from "@mui/material";
import {
  marginLeftToMarginRightOnRtl,
  onRtl,
} from "fe-web-components/rtl/rtlStyles";
import { ReactComponent as BottomWaveIcon } from "../../../assets/clinic/bottomWave.svg";
import { ThemeSettings } from "@kahunmedical/common-configuration";

//region [[ Styles ]]

const ChatWelcomePreviewView = styled("div")(
  (props: { theme?: any; customtheme: ThemeSettings }) => ({
    marginTop: 10,
    display: "flex",
    flexDirection: "column",
    minWidth: 430,
    minHeight: 300,
    borderRadius: 15,
    color: props.customtheme.colors["--homepage-link-color"],
    background: props.customtheme.gradient
      ? `radial-gradient(83.53% 86.88% at 45.87% -11.43%, ${props.customtheme.colors["--grad-light"]} 0%, ${props.customtheme.colors["--grad-dark"]} 100%);`
      : props.customtheme.homepageBackgroundImageUrl
      ? `url(${props.customtheme.homepageBackgroundImageUrl}) space space`
      : props.customtheme.colors["--grad-light"],
    padding: "50px 50px 175px",
    position: "relative",
    boxShadow: "0px 0px 14px rgba(0, 0, 0, 0.15)",
    overflow: "hidden",
    "& .bottom-view": {
      height: "200px",
      overflow: "hidden",
      background: "transparent",
      position: "absolute",
      display: "flex",
      left: 0,
      width: "100%",
      zIndex: 200,
      bottom: 0,
      alignItems: "end",
      justifyContent: "center",
      paddingBottom: 40,
      "& svg": {
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        zIndex: 0,
        width: "100%",
        height: "100%",
      },
      "& svg path": {
        filter: "drop-shadow(rgba(0, 0, 0, 0.5) 0px -3px 24px)",
        fill: "#FFFFFF",
      },

      "& .generic-button": {
        color: props.customtheme.colors["--button-text-color"],
        backgroundColor: props.customtheme.colors["--primary"],
        height: 44,
        fontWeight: 500,
        fontSize: 15,
        textTransform: "none",
        minWidth: 280,
        borderRadius: 30,
        boxShadow: "unset",
      },
    },
  }),
);

const LogoArea = styled("div")({
  display: "flex",
  alignItems: "center",
  paddingBottom: "20px",
  "& img": {
    maxWidth: "300px",
    minHeight: "50px",
  },
});

const WelcomeText = styled("div")({
  fontSize: "21px",
  fontWeight: 600,
  color: "var(--homepage-text-color)",
  ...marginLeftToMarginRightOnRtl(15),
});

const TermsOfServiceText = styled("div")({
  fontSize: "17px",
  fontWeight: 500,
  whiteSpace: "break-spaces",
  paddingBottom: "5px",
});

const WelcomeTitle = styled("div")({
  fontSize: "17px",
  fontWeight: 700,
  // color: "white",
  marginTop: "10px",
  paddingBottom: "0px",
});

const LinkSection = styled("div")({
  marginTop: "10px",
  fontSize: "14px",
  color: "var(--homepage-link-color)",
  display: "flex",
  alignItems: "end",
});

const VisitText = styled("div")({
  marginTop: "1px",
  marginLeft: 0,
  marginRight: 10,
  ...onRtl({
    marginRight: 0,
  }),
});

const WebsiteLink = styled(Link)({
  color: "var(--homepage-link-color)",
  textDecoration: "underline",
});

const CustomWelcomeText = styled("div")({
  background: "#00000050",
  padding: "10px 14px",
  borderRadius: 10,
  margin: "10px 0",
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ChatWelcomePreviewProps {
  customTheme: any;
  translate: any;
  customWelcome: string;
  rtlView?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ChatWelcomePreview = ({
  translate,
  ...props
}: ChatWelcomePreviewProps) => {
  return (
    <ChatWelcomePreviewView
      customtheme={props.customTheme}
      className={`chat-preview${props.rtlView ? " rtl-view" : ""}`}
      dir={props.rtlView ? "rtl" : ""}
    >
      <LogoArea>
        <WelcomeText>{translate("WELCOME_LOGO")}</WelcomeText>
      </LogoArea>
      <TermsOfServiceText>
        {translate("WELCOME_PARTNERS_1")}
        <CustomWelcomeText>{props.customWelcome}</CustomWelcomeText>
        {translate("WELCOME_PARTNERS_3")}
      </TermsOfServiceText>
      <WelcomeTitle>{translate("WELCOME_TITLE")}</WelcomeTitle>
      <LinkSection>
        <VisitText>{translate("VISIT")}</VisitText>
        <WebsiteLink href={"http://www.kahun.com"}>
          {translate("KAHUN_WEBSITE")}
        </WebsiteLink>
      </LinkSection>
      <div className="bottom-view">
        <BottomWaveIcon />
        <Button className="generic-button">{translate("GET_STARTED")}</Button>
      </div>
    </ChatWelcomePreviewView>
  );
};
